/**
 * This is a simple utility function that creates an empty object of type T.  Useful for having
 * a standardized way of creating instances for openapi model objects
 */
export function create<T>(defaults?: Partial<T>): T {
  return { ...defaults } as T;
}
